<ng-container *ngFor="let note of deliveryNotes; let i = index">
  <div class="ecmr-block deliverynote" [@fadeInOut]>
    <span class="ecmr-block-title">
      {{ note.shipmentKey }}
    </span>

    <ng-container *ngIf="!note.editable">
      <div class="ecmr-block-content">
        <div class="ecmr-block-row" *ngIf="note.deliverTo || note.clientNif">
          <div class="ecmr-block-col">
            <div class="name key">{{ note.deliverTo }}</div>
          </div>
          <div class="ecmr-block-col">
            <div class="key">{{ note.clientNif }}</div>
          </div>
        </div>
        <div class="ecmr-block-row">
          <div class="ecmr-block-col">
            <div class="address" *ngIf="note.clientAddress">{{ note.clientAddress }}</div>
            <div>{{ note.clientPostalCode }} {{ note.clientCity }}</div>
          </div>
          <div class="ecmr-block-col" *ngIf="note.deliveryDate">
            <div>{{ note.deliveryDate | date }}</div>
          </div>
        </div>
      </div>

      <div class="ecmr-block-content" *ngIf="note.delivery">
        <div *ngFor="let line of note.delivery.lines | sortBy:'line'">
          <shared-delivery-line class="line compact" [line]="line" [columns]="columnsByNote[i]"
            [allColumns]="allColumns" [readonly]="true" [showDelete]="false" [expanded]="isLineExpanded(line)"
            (expandToggled)="onExpandedLine(line)">
          </shared-delivery-line>
        </div>

        <div class="ecmr-block sub payment" *ngIf="note.delivery.totalKg">
          <div class="ecmr-block-row totalKg">
            <span class="value-text">{{'SHIPMENTDELIVERY.TOTALKG.CAPTION' | translate}}</span>
            <span class="key">{{ note.delivery.totalKg | quantity }}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <shared-shipment-delivery-component *ngIf="note.editable" [shipmentId]="note.shipmentId" [hideactions]="readonly" [inECMR]="true">
    </shared-shipment-delivery-component>
  </div>
</ng-container>
